<template>
    <Row>
        <Col span="24">
            <div class="footer"></div>
        </Col>
    </Row>
</template>

<script>
    export default {
        name: 'up',
    }
</script>

<style lang="scss">
    .footer{
        position: absolute;
        bottom:-5px;
        width:100%;
        height:55px;
        background-color: #9933CC;
    }
</style>
